import { IconCheck } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

export const IconCheckField = props => {
  const { onChange, value, ...rest } = props
  return (
    <IconCheck
      checked={value}
      onCheck={(e, checked) => onChange && onChange(checked)}
      {...rest}
    />
  )
}

export const IconCheckInput = makeAutobindedInput(IconCheckField)
